import React from 'react'

const ProgressSkill = ({skill, percentage}) => {
  return (
    <div className="progress">
        <span className="skill"><span>{skill}</span> <i className="val">{percentage}</i></span>
        <div className="progress-bar-wrap">
        <div className="progress-bar" style={{width: percentage}}></div>
        </div>
    </div>
  )
}

export default ProgressSkill